export interface ApiAISummaryResult {
  overview: string;
  text: string;
}
export enum ApiAIProcessingStatus {
  disabled = "disabled",
  waiting = "waiting",
  evaluating = "evaluating",
  completed = "completed",
  failed = "failed",
}
